export default __webpack_public_path__ + "assets/webgl/scene-12.db4bd9cd.glb";